import { Button, Card } from 'ui';
import ProgramImage from 'core/modules/components/general/ProgramImage/ProgramImage';
import { getDateFormat } from 'core/utils/date';
import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';

const LicenseItem = ({ name, thumbnail, level, education_level, code, start, end, program, t, onDelete, typeView = 'default' }) => {
  return (
    <Card padding="md">
      <div className={`license-item license-item--typeview-${typeView}`}>
        <div className="license-item__image">
          <ProgramImage course_picture={thumbnail} configProgramPicture={true} />
        </div>
        <div className="license-item__content">
          <div className="license-item__content-texts">
            <span className="license-item__content-name">{name}</span>
            <span className="license-item__content-level">
              {education_level && education_level.guid ? t(`education-levels:${education_level.guid}`) : level}

              {program.isbn && (
                <>
                  <> -</>
                  <span className="license-item__content-isbn">
                    {' '}
                    {t('common:ISBN')} {program.isbn}
                  </span>
                </>
              )}
            </span>
          </div>
          {start && typeView === 'default' && (
            <div className="license-item__content-meta-info">
              <span className="license-item__content-code">{code}</span>
              <span className="license-item__content-range">
                <span className="license-item__content-range-text">{t('From')} </span>
                <span className="license-item__content-range">{getDateFormat(start)} </span>
                <span className="license-item__content-range-text">{t('To').toLowerCase()}</span>
                <span className="license-item__content-range"> {getDateFormat(end)} </span>
              </span>
            </div>
          )}
          {onDelete && (
            <Button
              ariaLabel={t('signup:Remove license x', { name })}
              className="license-item__content-delete"
              isIconOnly
              leftIcon="trash"
              onClick={onDelete}
              variant="plain"
            />
          )}
        </div>
      </div>
    </Card>
  );
};

LicenseItem.propTypes = {
  code: PropTypes.string,
  education_level: PropTypes.shape({ guid: PropTypes.string }),
  end: PropTypes.string,
  level: PropTypes.string,
  name: PropTypes.string,
  onDelete: PropTypes.func,
  program: PropTypes.shape({ isbn: PropTypes.string }),
  start: PropTypes.string,
  t: PropTypes.func.isRequired,
  thumbnail: PropTypes.string,
  typeView: PropTypes.oneOf(['default', 'simple']),
};

export default withTranslation(['common', 'placeholder'])(LicenseItem);
